import {
  Button,
  IconButton,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Box,
  CircularProgress,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import DownloadIcon from "@material-ui/icons/CloudDownload";
import GetAppIcon from "@material-ui/icons/GetApp";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { decryptData } from "../../../../crypto";
import useStyles from "../../../../styles";
import QuestionHead from "../../../CustomComponent/QuestionHead";
import ResultHead from "../../../CustomComponent/ResultHead1";
import Loader from "../../../CustomComponent/Loader";
import TableView from "../../../CustomComponent/TableView";
import { ReactComponent as ResultIcon } from "../../../images/questionimage/resulticon.svg";

function ExamResult() {
  const classes = useStyles();
  const { rowId } = useParams();
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [searchQuery, setSearchQuery] = useState("");
  const [results, setResults] = useState([]);
  const [fileURL, setFileURL] = useState("");
  const navigate = useNavigate();
  const params = useParams();
  const [loaderOpen, setLoaderOpen] = useState(false);
  const [openPushModal, setOpenPushModal] = useState(false);
  const [pushResultData, setPushResultData] = useState(null);
  const [submittingPush, setSubmittingPush] = useState(false);

  const [pageSize, setPageSize] = useState(25);
  const [onPage, setOnPage] = useState(0);

  const [page, setPage] = useState(0);

  const handlePageChange = (newPage) => {
    setPage(newPage);
    setOnPage(newPage); // Pass newSelection directly
  };

  const [rowCount, setRowCount] = useState("");

  const [examDetails, setExamDetails] = useState({
    examName: "",
    examCode: "",
    courseName: "",
    batchName: "",
    subjectNames: "",
    examImage: "",
  });

  useEffect(() => {
    const fetchExamData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/${rowId}`,
          {
            headers: {
              Authorization: `Bearer ${decryptedToken}`,
            },
          },
        );

        const exam = response.data.exam;
        const subjectNames = exam.subjects
          .map((sub) => sub.subject_name)
          .join(", ");

        setExamDetails({
          examName: exam.exam_name,
          examCode: exam.exam_code || "",
          courseName: exam.course.map((c) => c?.course_name).join(", "),
          batchName: exam.batch.map((c) => c?.batch_name).join(", "),
          subjectNames: subjectNames,
          examImage: exam.image_url,
        });
      } catch (error) {
        console.error("Error fetching exam data: ", error);
      }
    };

    fetchExamData();
  }, [rowId, decryptedToken]);

  const fetchData = async (rowId, pageNumber, size, search) => {
    if (!Number.isFinite(pageNumber) || !Number.isFinite(size)) return;

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/result/${rowId}?page=${pageNumber + 1}&limit=${size}&search=${search}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );

      setResults(response.data.exam_results);
      setRowCount(response.data.total_count);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };
  useEffect(() => {
    if (
      onPage !== undefined &&
      pageSize !== undefined &&
      searchQuery !== undefined
    ) {
      fetchData(rowId, onPage, pageSize, searchQuery);
    }
  }, [rowId, onPage, pageSize, searchQuery]);

  // const exportResultApi = async (rowId) => {
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/export/${rowId}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${decryptedToken}`,
  //         },
  //       }
  //     );

  //     if (response.status === 200) {
  //       // toast.success("Result CSV has been downloaded successfully.");
  //       setFileURL(response.data.file_url);
  //     } else {
  //       // toast.error("Failed to download the CSV file.");
  //     }
  //   } catch (error) {
  //     const errorMessage = error.response && error.response.data.message ? error.response.data.message : "An error occurred while fetching the data.";
  //     // toast.error(errorMessage);
  //   }
  // };
  // useEffect(() => {
  //   exportResultApi(rowId);
  // }, [rowId]);

  const navigateToAnswer = async (userId, student_name) => {
    setLoaderOpen(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/result/${rowId}`,
        {
          user_id: userId,
        },
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );
      console.log(response);
      if (response.data.success === true) {
        const examResult = response.data;
        setLoaderOpen(false);
        navigate(`/admin/examresult/:${params.rowId}/examscore`, {
          state: {
            examResult: JSON.stringify(examResult),
            studentName: student_name,
            examName: examDetails.examName,
          },
        });
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      setLoaderOpen(false);
    }
  };

  const handleDownloadScreenshot = (screenshot, studentName, rollNumber) => {
    if (!screenshot || screenshot === "N/A") {
      toast.error("Screenshot is not available.");
      return;
    }

    try {
      const cleanRoll = (rollNumber || "Student")
        .toString()
        .trim()
        .replace(/[^a-zA-Z0-9_\-]/g, "_");
      const cleanName = (studentName || "Result")
        .toString()
        .trim()
        .replace(/[^a-zA-Z0-9_\-]/g, "_");
      const fileName = `${cleanRoll}_${cleanName}_summary_screenshot.png`;

      let contentType = "image/png";
      let base64String = screenshot;

      if (screenshot.startsWith("data:")) {
        const parts = screenshot.split(",");
        const mimeMatch = parts[0].match(/:(.*?);/);
        if (mimeMatch) {
          contentType = mimeMatch[1];
        }
        base64String = parts[1] || "";
      }

      base64String = base64String.replace(/\s/g, "");

      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: contentType });
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);

      toast.success("Screenshot downloaded successfully!");
    } catch (error) {
      console.error("Error downloading screenshot:", error);
      try {
        const link = document.createElement("a");
        link.href = screenshot.startsWith("data:")
          ? screenshot
          : `data:image/png;base64,${screenshot}`;
        link.download = `${(rollNumber || "Student")
          .toString()
          .replace(/[^a-zA-Z0-9_\-]/g, "_")}_summary_screenshot.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success("Screenshot downloaded successfully!");
      } catch (fallbackError) {
        console.error("Fallback download failed:", fallbackError);
        toast.error("Failed to download screenshot.");
      }
    }
  };

  const rows = results.map((d) => ({
    id: d.id ? d.id : "N/A",
    student_name: d.student_name ? d.student_name : "N/A",
    roll_number: d.roll_number ? d.roll_number : "N/A",
    center_code: `${d.center_code || "N/A"} - ${d.center_name || "N/A"}`,
    center: d.center ? d.center : "N/A",
    phone: d.phone ? d.phone : "N/A",
    received_marks:
      d.received_marks !== null && d.received_marks !== undefined
        ? d.received_marks
        : "N/A",

    correct_answer:
      d.correct_answer !== null && d.correct_answer !== undefined
        ? d.correct_answer
        : "N/A",
    incorrect_answer:
      d.incorrect_answer !== null && d.incorrect_answer !== undefined
        ? d.incorrect_answer
        : "N/A",
    user_id: d.user_id,

    email: d.email ? d.email : "N/A",
    total_score: d.total_score ? d.total_score : "N/A",
    total_questions: d.total_questions ? d.total_questions : "N/A",
    active_status: d.active_status ? d.active_status : "N/A",
    summary_screen_shot:
      d.summary_screen_shot || d.summary_screen_short || null,
  }));
  const startIndex = onPage * pageSize;
  const filteredRows = rows.map((row, index) => ({
    ...row,
    srno: startIndex + index + 1,
  }));

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  const handlePushResult = async () => {
    const code = examDetails.examCode;
    if (!code) {
      toast.error("Exam Code is not available.");
      return;
    }

    setLoaderOpen(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/send/uid_merge_report?exam_code=${code}&passkey=fe8a4dc60dae61505f2ee71912415529`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      const resData = response.data;
      setPushResultData(resData);
      console.log("resData", resData);
      setOpenPushModal(true);
    } catch (error) {
      console.error("Error fetching push result details: ", error);
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while fetching push result details.";
      toast.error(errorMessage);
    } finally {
      setLoaderOpen(false);
    }
  };

  const handleSubmitPushResult = async () => {
    setSubmittingPush(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/question/unacademy/share-result-api`,
        pushResultData || {},
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      const resData = response.data;
      const getErrorMessage = (data) => {
        if (!data) return null;
        if (Array.isArray(data.errors) && data.errors.length > 0) {
          return data.errors.join(", ");
        }
        if (typeof data.errors === "string") {
          return data.errors;
        }
        if (data.message) {
          return data.message;
        }
        return null;
      };

      if (resData?.status === "Rejected" || (resData?.errors && resData.errors.length > 0)) {
        const errorMsg = getErrorMessage(resData) || "Failed to upload result.";
        toast.error(errorMsg);
      } else if ((response.status >= 200 && response.status < 300) || resData?.success) {
        toast.success(resData?.message || "Result uploaded successfully!");
        setOpenPushModal(false);
      } else {
        const errorMsg = getErrorMessage(resData) || "Failed to upload result.";
        toast.error(errorMsg);
      }
    } catch (error) {
      console.error("Error submitting push result: ", error);
      const resData = error.response?.data;
      let errorMessage = "An error occurred while uploading the result.";
      if (resData) {
        if (Array.isArray(resData.errors) && resData.errors.length > 0) {
          errorMessage = resData.errors.join(", ");
        } else if (typeof resData.errors === "string") {
          errorMessage = resData.errors;
        } else if (resData.message) {
          errorMessage = resData.message;
        }
      }
      toast.error(errorMessage);
    } finally {
      setSubmittingPush(false);
    }
  };

  const Result = [
    {
      id: 1,
      pageicon: <ResultIcon />,
      mainheading: "Students Results",
      searchlabel: "Search By Student Name/Roll No.",
      // placeholder: "Search By Class",
      // report1: "report01",
      // report2: "report02",
      // report3: "report03",
      // report4: "report04",
      // report5: "report05",
      // report6: "report06",
      pushResult: true,
      height: "maxh67",
      style: "viewtable",
      footer: false,
      setPageSize: setPageSize,
      pageSize: pageSize,
      rowCount: rowCount,
      handlePageChange: handlePageChange,
      page: page,
      paginationMode: "server",
    },
  ];
  const columns = [
    {
      field: "srno",
      headerName: "Sr.No",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 70,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "roll_number",
      headerName: "Roll Number",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "student_name",
      headerName: "Student Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    // {
    //   field: "phone",
    //   headerName: "Phone",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   width: 200,
    //   flex: 1,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   autoPageSize: false,
    // },
    {
      field: "center",
      headerName: "Center Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "total_questions",
      headerName: "Total Questions",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "correct_answer",
      headerName: "Correct Answers",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "incorrect_answer",
      headerName: "Incorrect Answers",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "received_marks",
      headerName: "Recieved Marks",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "active_status",
      headerName: "View Result",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      width: 100,
      autoPageSize: false,
      renderCell: (params) => {
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Button
              startIcon={<DownloadIcon color="success" />}
              onClick={() =>
                navigateToAnswer(params.row.user_id, params.row.student_name)
              }
            />
          </div>
        );
      },
    },
    {
      field: "summary_screen_shot",
      headerName: "Screenshot",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      width: 110,
      autoPageSize: false,
      renderCell: (params) => {
        const screenshot =
          params.row.summary_screen_shot || params.row.summary_screen_short;
        const hasScreenshot = Boolean(screenshot && screenshot !== "N/A");

        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Button
              disabled={!hasScreenshot}
              title={
                hasScreenshot
                  ? "Download Screenshot"
                  : "Screenshot Not Available"
              }
              startIcon={
                <GetAppIcon color={hasScreenshot ? "primary" : "disabled"} />
              }
              onClick={() =>
                handleDownloadScreenshot(
                  screenshot,
                  params.row.student_name,
                  params.row.roll_number
                )
              }
            />
          </div>
        );
      },
    },
  ];

  const Heading = [
    {
      id: 1,
      logo: examDetails.examImage,
      path: "/admin/exam",
      headings: [
        {
          id: 11,
          label: "Name",
          content: examDetails.examName,
        },
        // {
        //   id: 12,
        //   label: "Subject",
        //   content: examDetails.subjectNames,
        // },
        {
          id: 13,
          label: "Course",
          content: examDetails.courseName,
        },
        {
          id: 14,
          label: "Batch",
          content: examDetails.batchName,
        },
      ],
    },
  ];

  return (
    <>
      <ToastContainer />
      <div
        className={`${classes.p2} ${classes.pb0} ${classes.pt1} ${classes.pagescroll} ${classes.h90vh}`}
      >
        <QuestionHead Heading={Heading} />
        <div className={`${classes.mt1}`}>
          <Loader loaderOpen={loaderOpen} />
          <ResultHead
            result={true}
            rowId={rowId}
            decryptedToken={decryptedToken}
            onSearch={handleSearch}
            Heading={Result}
            setLoaderOpen={setLoaderOpen}
            searchQuery={searchQuery}
            handlePushResult={handlePushResult}
          />
          <TableView columns={columns} rows={filteredRows} Heading={Result} />
        </div>
      </div>

      <Dialog
        open={openPushModal}
        onClose={() => setOpenPushModal(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          style: { borderRadius: "12px", padding: "8px" },
        }}
      >
        <DialogTitle disableTypography style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px 8px 16px" }}>
          <Typography variant="h6" style={{ fontWeight: 600, color: "#00577B" }}>
            Push Result Details
          </Typography>
          <IconButton onClick={() => setOpenPushModal(false)} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box py={1}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="body2" color="textSecondary">
                  Quiz UID:
                </Typography>
                <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
                  {pushResultData?.quiz_uid || pushResultData?.exam_code || examDetails.examCode || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2" color="textSecondary">
                  Total Learners:
                </Typography>
                <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
                  {pushResultData?.total_learners ?? "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2" color="textSecondary">
                  Total Questions:
                </Typography>
                <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
                  {pushResultData?.total_questions ?? "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2" color="textSecondary">
                  Total Records:
                </Typography>
                <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
                  {pushResultData?.total_records ?? "N/A"}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions style={{ padding: "16px 24px" }}>
          <Button
            onClick={() => setOpenPushModal(false)}
            color="default"
            variant="outlined"
            disabled={submittingPush}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmitPushResult}
            color="primary"
            variant="contained"
            disabled={submittingPush}
            style={{ backgroundColor: "#00577B", color: "#fff" }}
          >
            {submittingPush ? (
              <CircularProgress size={20} style={{ color: "#fff" }} />
            ) : (
              "Upload"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
export default ExamResult;
